export default "__VITE_ASSET__WwUlsNRk__"